
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`We've added a new Dark theme to our themes package. We've also started adding Hybrid code examples for our design patterns. We're also happy to introduce our new component libraries.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;